import React from 'react';
import PropTypes from 'prop-types';
import {GenericButton} from "../../../components/buttons/customButtons";


function EventItem(props) {
    const {item, index, onEdit, onEditItinerary, onEditSections} = props;

    const onClick = () => {
        onEdit(item);
    }

    return (
        <div id={'promotion-item'} key={'promotion-item-' + index} className={'promotion-item'} >
            <h3 className="code" onClick={onClick}>{item?.code}</h3>
            <img className={'image' + (!item?.status ? ' grayscale' : '')} src={item?.mediaUrl} alt={item?.code} onClick={onClick}/>
            <div className={'top-right-fixed'}>
                <GenericButton
                    style={'table'}
                    toolTip={'Itinerario'}
                    icon={'fa-calendar-check'}
                    permission={'edit'}
                    onClick={_ => onEditItinerary(item)}/>

                <GenericButton
                    style={'table'}
                    toolTip={'Fichas dinamicas'}
                    icon={'fa-columns'}
                    permission={'edit'}
                    onClick={_ => onEditSections(item, index)}/>
            </div>
        </div>
    );
}

EventItem.propTypes = {
    item: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired
};

export default EventItem;